import { Breakpoints } from '@/utils/breakpoints';

export function extractValidValuesFromObjBreakpoints(
  obj: Record<string, unknown>,
  breakpoint: Breakpoints
) {
  const extractedProps: Record<string, unknown> = {};

  Object.entries(obj).forEach(([key, value]) => {
    if (key.startsWith(breakpoint)) {
      if (!value) return;

      const newKey = key.replace(breakpoint, '').toLowerCase();
      extractedProps[newKey] = value;
    }
  });

  return extractedProps;
}

export const slugify = (title?: string) => {
  if (!title) return '';

  const initialNumberingRegex = /^([0-9]\.\s?)+/g;
  const spacesRegex = /\/|\s+/g;
  const punctuationRegex = /[^a-zA-Z0-9\u4e00-\u9fa5-]+/g;

  return title
    .toLowerCase()
    .trim()
    .replaceAll(initialNumberingRegex, '')
    .replaceAll(spacesRegex, '-')
    .replaceAll('&', 'and')
    .replaceAll(punctuationRegex, '');
};

export type SectionFit = 'full' | 'mid' | 'contained';
/**
@description maps to TW's layer-base custom max-width values in globals.css
 */
export function getWrapperMaxWidth(fit: SectionFit): string {
  if (fit === 'full') {
    return 'max-w-section-full';
  }
  if (fit === 'mid') {
    return 'max-w-section-mid';
  }

  return 'max-w-section-contained';
}
